import { reactive, onMounted, onUnmounted } from "vue";
import AppointmentService from "@/services/office/appoinmentsService";
import TaskService from "../office/tasksService";
import { SocketOffice } from "@/services/sockets/officeSocket";

export function useSidebarBadges() {
  // Estado reactivo para los contadores
  const counters = reactive({
    appointmentTodayCount: 0,
    toDoTaskCount: 0,
  });

  // --- LÓGICA TURNOS ---
  const fetchTurnos = async () => {
    try {
      const response = await AppointmentService.getAppointmentsByWeek();
      if (!response.success) return;

      const today = new Date();
      const daysOfWeek = [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
      ];
      const todayName = daysOfWeek[today.getDay()];

      if (response.data && response.data.Appointments) {
        counters.appointmentTodayCount = response.data.Appointments[todayName] || 0;
      }
    } catch (e) {
      console.error("Error fetching turnos badge", e);
    }
  };

  // --- LÓGICA TAREAS ---
  const fetchTareas = async () => {
    try {
      const response = await TaskService.getToDoQuantity();
      if (response && (response.success || response.data !== undefined)) {
        counters.toDoTaskCount =
          typeof response.data === "number" ? response.data : 0;
      }
    } catch (e) {
      console.error("Error fetching tareas badge", e);
    }
  };

  // --- ACTUALIZACIÓN GLOBAL ---
  const refreshAll = () => {
    fetchTurnos();
    fetchTareas();
  };

  const setupSocketListeners = () => {
    SocketOffice?.on("tasks:update", fetchTareas);
    SocketOffice?.on("appoinments:update", fetchTurnos);
  };

  const removeSocketListeners = () => {
    SocketOffice?.off("tasks:update", fetchTareas);
    SocketOffice?.off("appoinments:update", fetchTurnos);
  };

  onMounted(() => {
    refreshAll();
    setupSocketListeners();
  });

  onUnmounted(() => {
    removeSocketListeners();
  });

  return {
    counters,
    refreshAll,
  };
}
